

















































import Vue from 'vue'
import { Multimedia } from '@/model/Multimedia'
import FormData from 'form-data'

export default Vue.extend({
  name: 'AddImageDialog',
  props: {
    value: {
      type: Boolean,
    },
  },
  data: () => ({
    loading: false,
    uploadedImages: [] as Multimedia[],
    selectedImages: [] as File[],
    errors: [] as string[],
  }),
  methods: {
    init: function () {
      this.loading = false
      this.uploadedImages = []
      this.selectedImages = []
      this.errors = []
    },
    cancelClick: function () {
      this.$emit('input', false)
      this.init()
    },
    addImagesClick: function () {
      this.$emit('addUploadedImagesClick', this.uploadedImages)
      this.$emit('input', false)
      this.init()
    },
    upload: function () {
      if (this.selectedImages.length === 0) {
        this.$store.dispatch(
          'alert/warning',
          'You need to select images first.'
        )
        return
      }

      this.loading = true

      const userId = this.$store.state.authentication.user
        ? this.$store.state.authentication.user.id
        : 'x-unknown'

      const promises = []

      this.errors = []

      for (const file of this.selectedImages) {
        if (file.size > 5000000) {
          this.errors.push('Image ' + file.name + ' is too big.')
          continue
        }
        const formData = new FormData()
        formData.append('file', file, file.name)
        formData.append('name', file.name)
        formData.append('description', file.name)
        formData.append('domain', 'client/user/' + userId + '/proj/img')
        promises.push(
          this.$api
            .post('/multimedia', formData)
            .then((response) => this.uploadedImages.push(response.data))
        )
      }

      Promise.all(promises)
        .then(() => {
          this.selectedImages = []
          if (this.errors.length > 0) {
            this.$store.dispatch(
              'alert/warning',
              'There were some problems during upload. Please check Add Images dialog.'
            )
            return
          }
          this.$store.dispatch(
            'alert/success',
            'Images uploaded! Click Add Images to add them to your project.'
          )
        })
        .catch(() =>
          this.$store.dispatch('alert/error', 'Problems during images upload.')
        )
        .finally(() => (this.loading = false))
    },
  },
})
